import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { IEscrowFileResponse } from '../../types/accounting/response/IEscrowFileResponse';
import { IEscrowFileData } from '../../types/accounting/data/IEscrowFileData';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';

export const getEscrowFileByOrderIdAsync = async (orderId: string): Promise<IEscrowFileData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IEscrowFileResponse>('/timber/api/internal/escrow/files', {
      params: { orderId },
    })
    .then((response) => response.data)
    .catch(axiosErrorHandler);
